// Averiguo si estoy en el browser para localizar o no los mensajes y no lanzar errores en los test
const RES: any = (typeof window !== 'undefined' && window.RES) || {};

export function get(lang: string, key: string): string {
	return RES[lang] && RES[lang][key];
}

export function set(lang: string, key: string, value: string): void {
	(RES[lang] = RES[lang] || {})[key] = value;
}
